/**
 * Created with IntelliJ IDEA.
 * User: noam
 * Date: 1/14/14
 * Time: 5:33 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("content-templates/content-edit/skillTabs.tmpl");
    var TabsBar = require("ui/tabsbar/TabsBar");

    var SkillTabsView = {};

    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {

        SkillTabsView = Marionette.ItemView.extend({
            template:  template,
            className: "tabi-tabi",

            ui: {
                tabsLabel: ".tabs-label",
                tabsBarContainer: ".tabs-container"
            },
            uiComponents: {
                tabsBar: {
                    type: TabsBar,
                    options: {
                        el: "view.ui.tabsBarContainer",
                        collection: "view._getTabsCollection",
                        commitStateChange: false,
                        permutation: TabsBar.PERMUTATION.B,
                        additionalEllipsisClass: "skillEllipsis"
                    },
                    events: {
                        "change:selection": "_clickSkillTab",
                        "click:tabButton": "_addButtonClicked"
                    }

                }

            },

            initialize: function (options) {
                LEContent.logger.debug("Initializing SkillTabsView", "SkillTabsView:initialize");
                options = options || {};
                this.channel = options.channel;
                this.reqres = options.reqres;
                this.tabsLabel = options.tabsLabel;
                this.bindEvents();
            },
            onBeforeRender: function () {
                LEContent.logger.debug("onBeforeRender SkillTabsView", "SkillTabsView:onBeforeRender");
            },
            onRender: function () {
                this._updateLabel();
                LEContent.logger.debug("onRender SkillTabsView", "SkillTabsView:onRender");
            },

            bindEvents: function () {
                this.listenTo(this.model,"change:model",this._updateViewWithChangedModel,this);
            },
            _addButtonClicked: function(){
                this.channel.trigger("skillTabView:add:skills");
            },
            _updateViewWithChangedModel: function(){
                this._hideErrors();
            },
            _hideErrors:function () {
                this.uiComponents.tabsBar.setErrorOnTab(false);
            },
            //Tabs
            _getTabsCollection: function () {
                return this.model.getSkillTabCollection();
            },
            _clickSkillTab: function (component, eventName, tabId, view) {
                this.channel.trigger("skillTabsView:click:tab", tabId, view);
            },
            _updateLabel: function () {
                if(!this.tabsLabel) {
                    this.ui.tabsLabel.text(this.tabsLabel);
                }
            },
            onClose: function () {
                LEContent.logger.debug("onClose SkillTabsView", "SkillTabsView:onClose");
            }
        });

    });
    return SkillTabsView;
});
